import { JSONContent } from '@tiptap/core';
import { Fragment, Node } from '@tiptap/pm/model';
import { TiptapJson } from 'api/page-template/types';
import { EditorNodeInfo } from '../types';
import { compareNodes } from './comparator';

/**
 * searches for a node in the content and returns the node info if found
 * @param content - The content to search in.
 * @param targetNode - The node to search for.
 * @param searchFrom - The start position to search from.
 * @param searchTo - The end position to search to.
 */
export const findNodeInContent = (
  content: Node,
  targetNode: Node,
  searchFrom: number = 0,
  searchTo: number = content.nodeSize,
): EditorNodeInfo | null => {
  let found: EditorNodeInfo | null = null;

  content.nodesBetween(searchFrom, searchTo, (node, start) => {
    if (compareNodes(node, targetNode)) {
      found = {
        node,
        start,
        end: start + node.nodeSize,
        contentStart: start + 1,
        contentEnd: start + node.content.size,
      };

      return false;
    }

    return true;
  });

  return found;
};

export const calculateFragmentDepth = (fragment: Fragment) => {
  let openStart = 0;
  let openEnd = 0;

  // Calculate openStart - traverse down first child
  let node = fragment.firstChild;

  while (node && !node.isLeaf) {
    openStart++;
    node = node.firstChild;
  }

  // Calculate openEnd - traverse down last child
  node = fragment.lastChild;
  while (node && !node.isLeaf) {
    openEnd++;
    node = node.lastChild;
  }

  return { openStart, openEnd };
};

export const fragmentJSONToEditorContent = (
  json: JSONContent[],
): TiptapJson => {
  return {
    type: 'doc',
    content: json,
  };
};

export const isNodeEmpty = (node: Node) => {
  return node.content.size === 0;
};
